// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"21":"ce53ca91","22":"bf40036c"}[chunkId] + ".js";
};